import github from '../img/github.svg'
import python from '../img/Python.svg'
import r_studio from '../img/r_studio.png'
import sql from '../img/sql.png'
import react_icon from '../img/react.png'
import tableau from '../img/tableau.svg'
import aws from '../img/aws.png'
import airflow from '../img/airflow.svg'
import {StyledAbout,StyledDescription} from '../styles.js';
import styled from 'styled-components';
import {UseScroll} from './UseScroll.js';
import { useTable } from 'react-table';
const ServicesSection = () => {

    
    return (

        <Services>
            <StyledDescription>
                <h2> My <span> Skillset </span> </h2>

                <StyledCards>
                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={python} alt="efficient"/>
                            <h3>Python</h3>
                        </div>
                        <ul>
                            
                            <li> <span>Experience: </span> 4yrs </li>  
                            <li> <span>Highlight: </span>Experience working in Pytorch, Mxnet, Tensorflow/Keras for deep learning and Django, Streamlit for developing full stack apps. </li>
                        </ul>
                    </StyledCard>

                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={r_studio} alt="teamwork"/>
                            <h3>R</h3>
                        </div>
                        <ul>
                            
                            <li> <span>Experience: </span> 5yrs </li>  
                            <li> <span>Highlight: </span>Experience developing full-stack apps in R Shiny</li>
                        </ul>
                    </StyledCard>

                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={sql} alt="efficient"/>
                            <h3>SQL</h3>
                        </div>
                        <ul>
                            <li> <span>Experience: </span> 6yrs </li>  
                            <li> <span>Highlight: </span>Experience in Query Optimization, using CTE's, Window functions etc.</li>
                        </ul>
                    </StyledCard>

                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={react_icon} alt="efficient"/>
                            <h3>ReactJS</h3>
                        </div>
                        <ul>
                            <li> <span>Experience: </span> 0.5yrs </li>  
                            <li> <span>Highlight: </span>Made this Website using ReactJS</li>
                        </ul>
                    </StyledCard>

                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={tableau} alt="efficient"/>
                            <h3>Tableau</h3>
                        </div>
                        <ul>
                            <li> <span>Experience: </span> 1yr </li>  
                            <li> <span>Highlight: </span>Click Here to see some of my work</li>
                        </ul>
                    </StyledCard>

                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={aws} alt="efficient"/>
                            <h3>AWS</h3>
                        </div>
                        <ul>
                            <li> <span>Experience: </span> 1yr </li>  
                            <li> <span>Highlight: </span>Deploying ML models and data pipelines using AWS Lambda, Eventbridge, EC2, ECR, Cloudwatch events, Sagemaker etc.</li>
                        </ul>
                    </StyledCard>

                    <StyledCard>
                        <div className="icon">
                            <img style={{height:'50px'}} src={airflow} alt="efficient"/>
                            <h3>Airflow</h3>
                        </div>
                        <ul>
                            <li> <span>Experience: </span> 0.5yrs </li>  
                            <li> <span>Highlight: </span>Deploying airflow DAGS on AWS MWAA and Astronomer </li>
                        </ul>
                    </StyledCard>

                </StyledCards>

            </StyledDescription>


        </Services>

    )
}

const Services = styled(StyledAbout)`
h2{
    padding-bottom:5rem;
}
h3{
    padding-bottom:6rem;
}

p{
    width:70%;
    font-size:110%;
    margin-left:4rem;
    /* padding:2rem 0rem 4rem 0rem; */
}

li{
    margin-top:1rem;
    margin-left:5rem;
    justify-content:left;
}


`

const StyledCards = styled.div`
display:flex;
flex-wrap:wrap; 
@media (max-width:1020px){
     /* justify-content:center; */
 }
`

const StyledCard = styled.div`
flex-basis:15rem;
padding-bottom:3rem;
.icon{
    display:flex; 
    /* align-items: center;  */
    h3{
        margin-left:2rem;
        // background:#d1d0d0;
        color:#ccc;
        padding:0.5rem 2rem 0.5rem 2rem;

    }
    p{
        /* margin-left:3rem; */
    }
}

`

export default ServicesSection;